module.exports = __webpack_public_path__ + "e55f8f6b1d1c1728a351ed3aeff38424.fbx";